const DEFAULT_WORK_HOURS_PER_DAY = 8
const DEFAULT_WORK_DAYS_PER_WEEK = 5

export const getEstimationTimeSettings = (projectData) => ({
    defaultTime:
        Number(projectData?.defaultTime) > 0
            ? Number(projectData.defaultTime)
            : DEFAULT_WORK_HOURS_PER_DAY,
    defaultWeek:
        Number(projectData?.defaultWeek) > 0
            ? Number(projectData.defaultWeek)
            : DEFAULT_WORK_DAYS_PER_WEEK,
})

export const estimateFn = (value, currentProjectData, name) => {
    let estimateMinutes = `0m`
    let estimateHours = `0h`
    let estimateWeeks = `0w`
    let estimateDays = `0d`
    const { defaultTime, defaultWeek } =
        getEstimationTimeSettings(currentProjectData)

    let minutes = value
    if (minutes > 60) {
        estimateMinutes = `${parseInt(minutes % 60)}m`
        const hours = parseInt(minutes / 60)
        if (hours >= defaultTime) {
            estimateHours = `${hours % defaultTime}h`
            const days = parseInt(hours / defaultTime)
            if (days > defaultWeek) {
                estimateDays = `${days % defaultWeek}d`
                estimateWeeks = `${parseInt(days / defaultWeek)}w`
            } else {
                estimateDays = `${parseInt(days)}d`
            }
        } else {
            estimateHours = `${parseInt(hours)}h`
        }
    } else {
        if (name === 'reports') {
            estimateMinutes = `${parseInt(minutes)}m`
        } else {
            estimateMinutes = `${parseInt(minutes)}m`
        }
    }

    return `${estimateWeeks.split('w')[0] !== '0' ? estimateWeeks : ''} ${
        estimateDays.split('d')[0] !== '0' ? estimateDays : ''
    } ${estimateHours.split('h')[0] !== '0' ? estimateHours : ''} ${
        estimateMinutes.split('m')[0] !== '0' ? estimateMinutes : ''
    }`
}

export const formatEstimationDisplay = (value, currentProjectData) => {
    if (value == null || value === '' || Number(value) === 0) return ''
    return estimateFn(value, currentProjectData).replace(/\s+/g, ' ').trim()
}

export const parseEstimationToMinutes = (value, currentProjectData) => {
    if (!value || !String(value).trim()) return 0

    const { defaultTime, defaultWeek } =
        getEstimationTimeSettings(currentProjectData)
    let estimateMinutes = 0

    String(value)
        .trim()
        .toLowerCase()
        .split(/\s+/)
        .forEach((data) => {
            if (!data) return
            if (data.includes('w')) {
                estimateMinutes +=
                    (parseInt(data.split('w')[0], 10) || 0) *
                    defaultWeek *
                    defaultTime *
                    60
            } else if (data.includes('d')) {
                estimateMinutes +=
                    (parseInt(data.split('d')[0], 10) || 0) * defaultTime * 60
            } else if (data.includes('h')) {
                estimateMinutes += (parseInt(data.split('h')[0], 10) || 0) * 60
            } else if (data.includes('m')) {
                estimateMinutes += parseInt(data.split('m')[0], 10) || 0
            } else {
                estimateMinutes += parseInt(data, 10) || 0
            }
        })

    return Number.isNaN(estimateMinutes) ? 0 : estimateMinutes
}
